(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-necktie"]) return;
  try {
    
const hamburger = document.querySelectorAll('.js-hamburger');
const body = document.getElementsByTagName('body')[0];
hamburger.forEach((elm)=>{
  elm.addEventListener('click',function(e){
    if(body.classList.contains('open-hamburger')) {
      body.classList.remove('open-hamburger')
      body.classList.remove('overflow-hidden')
    } else{
      body.classList.add('open-hamburger')
      body.classList.add('overflow-hidden')
    }
  })
})
const headerOverlay = document.querySelector('.header__overlay');
headerOverlay.addEventListener('click',(e)=>{
  if(!e.target.closest('.header__menu')){
    body.classList.remove('open-hamburger')
      body.classList.remove('overflow-hidden')
  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
const body = document.getElementsByTagName('body')[0];
const productPage = document.querySelector('.product-info'); 
const productWrapper = document.querySelectorAll('.product__info-container')[0];
const productTitle = productWrapper.querySelector('.product__title');
const productMainvisual = productWrapper.querySelector('.item__mainvisual');
const productDescription = productWrapper.querySelector('.item__description');
const variantTitle = productWrapper.querySelector('.item__variant__title');
const necktieModals = productWrapper.querySelectorAll('.necktie-modal');
// const noticeModalTrigger = productWrapper.querySelector('.product__notice-modal__trigger ');
if(productMainvisual) {
  productWrapper.insertBefore(productMainvisual,productTitle);
}
if(productDescription) {
  productWrapper.insertBefore(productDescription,productTitle.nextSibling);
}
if(variantTitle) {
  productWrapper.insertBefore(variantTitle,productDescription.nextSibling);
}
if(necktieModals) {
  necktieModals.forEach(element => {
    document.body.appendChild(element);
  });
}
// if(noticeModal) {
//   document.body.appendChild(noticeModal);
//   noticeModal.querySelector('.product__notice-modal__close').addEventListener('click',(e)=>{
//     noticeModal.classList.remove('is-open');
//     body.classList.remove('overflow-hidden')
//   })
// }
// if(noticeModalTrigger) {
//   noticeModalTrigger.addEventListener('click',(e)=>{
//     e.preventDefault();
//     noticeModal.classList.add('is-open');
//     body.classList.add('overflow-hidden')
//   })
// }


// 関連追加商品のヴァリエーション制御
document.querySelectorAll('.related_product__variants').forEach((elm)=>{
  elm.querySelectorAll('input[type="radio"]').forEach((radio)=>{
    radio.addEventListener('change',function(e){
      // console.log(e.currentTarget.value)
      const productVariantId = e.target.closest('.related-product').querySelector('.product-form').querySelector('.product-variant-id');
      productVariantId.value = e.currentTarget.value;
    })
  })
})

productPage.classList.remove('in-preparation');




  } catch(e) { console.error(e); }
})();
})();
